import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../globals'
import { IepService } from "../../../Services/IepService";
import { IIepInstance } from '../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { SPTProcessService } from '../../../Services/SPTProcessService';
import { ISPTProcess } from "../../../Models/ISPTProcess";
import { ISPTCaseFile } from "../../../Models/ISPTCaseFile";
import { ISPTReferral } from "../../../Models/ISPTReferral";
import { ISPTPreReferralStrategyForm } from "../../../Models/ISPTPreReferralStrategyForm";
import { ISPTMeetingLog } from "../../../Models/ISPTMeetingLog";
import { ISPTResponseToIntervention } from "../../../Models/ISPTResponseToIntervention";
import { ISPTDocument } from "../../../Models/ISPTDocument";
import { ISPTBlankDocument } from "../../../Models/ISPTBlankDocument";
import { Observable, throwError, of } from "rxjs";
import { ConfirmationService } from 'primeng/api';
import { ILookupBase } from '../../../Models/ILookupBase';
import { LookupService } from 'src/app/Services/LookupService';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { ISpedStudentDemographics } from '../../../Models/ISpedStudentDemographics'
import { DashboardDocumentService } from "../../../Services/DashboardDocumentService";

@Component({
  selector: 'SPTProcess',
  templateUrl: './SPTProcess.component.html',
  styleUrls: ['./SPTProcess.component.css'],
  providers: [ConfirmationService]
})

export class SPTProcessComponent implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  _lookupService: LookupService;
  _dashboardDocumentService: DashboardDocumentService;
  messages: Message[] = [];
  studentInfo: ISpedStudentDemographics;
  confirmDialogVisible = false;
  selectedIepInstance: IIepInstance;
  selectedCaseFileId: number;
  canEdit: boolean;
  canEditReferral: boolean;
  canEditPreReferralStrategies: boolean;
  canEditMeetingLog: boolean;
  canEditResponseToIntervention: boolean;
  canEditAncillaryDocument: boolean;
  canEditDocumentRepository: boolean;
  canCompleteCaseFile: boolean = false;
  validation: boolean;
  viewReferral: boolean;
  viewPreReferralStrategies: boolean;
  viewMeetingLog: boolean;
  viewResponseToIntervention: boolean;
  viewAncillaryDocument: boolean;
  viewDocumentRepository: boolean;
  saveClicked: boolean;
  showSpinner: boolean = false;
  sptProcess: ISPTProcess[] = [];
  sptCaseFileDB: any = [];
  sptReferralDB: any = [];
  sptPreReferralStrategyDB: any = [];
  sptMeetingLogDB: any = [];
  sptResponseToInterventionDB: any = [];
  sptDocument: ISPTDocument[] = [];
  sptDocumentDB: any = [];
  sptBlankDocument: ISPTBlankDocument[] = [];
  sptBlankDocumentDB: any = [];
  activeTab: number = 0;
  _lookupDocumentType: ILookupBase[];

  constructor
    (
      private globals: Globals,
      private _sPTProcessService: SPTProcessService,
      private confirmation: ConfirmationService,
      iepService: IepService,
      lookupService: LookupService,
      dashboardDocumentService: DashboardDocumentService,
      @Inject('BASE_URL') baseUrl: string) {
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this._lookupService = lookupService;
    this._dashboardDocumentService = dashboardDocumentService;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
  }

  ngOnInit(): void {
    if (this._myGlobals.selectedStudent.localStudentId != null) {
      this.GetSPTProcess();
    }
  }

  GetSPTProcess(): void {
    this.showSpinner = true;
    this._sPTProcessService.getAllSPTProcess(this._myGlobals.selectedStudent.localStudentId)
      .subscribe((res: ISPTProcess[]) => {
        this.sptProcess = res;
        this.showSpinner = false;
      },
        err => {
          this.errorHandler(err);
          this.showSpinner = false;
        }
      );
  }

  ViewSPTReferral(selectedCaseFileId) {
    this.selectedCaseFileId = selectedCaseFileId;
    //Default view tabs false
    this.viewPreReferralStrategies = false;
    this.viewMeetingLog = false;
    this.viewResponseToIntervention = false;
    this.viewAncillaryDocument = false;
    this.viewDocumentRepository = false;

    //Can Edit
    this.GetSPTCaseFile();
    //Referral Tab
    this.GetSPTReferralDetails()

    this.activeTab = 0;

    this.scrollToBottom();
  }

  RefreshStudentInfo() {
    this._dashboardDocumentService.refreshSpedStudentDemographicsAndContactsForSPT(this.selectedCaseFileId)
      .subscribe((res: ISpedStudentDemographics) => {
        this.studentInfo = res;
      },
        err => {
          this.errorHandler(err);
        }
      );
  }

  GetStudentInfo() {
    this._dashboardDocumentService.getSptStudent(this._baseUrl + 'api/DashboardDocument/GetSPTSpedStudentDemographics?sptCaseId=' + this.selectedCaseFileId)
      .subscribe((res: ISpedStudentDemographics) => {
        this.studentInfo = res;
      },
        err => {
          this.errorHandler(err);
        }
      );
  }

  GetSPTCaseFile() {
    this._sPTProcessService.getSPTCaseFile(this.selectedCaseFileId)
      .subscribe((res: ISPTCaseFile) => {
        this.sptCaseFileDB = res;
        this.canEdit = this.sptCaseFileDB.canEdit;
        if (this.sptCaseFileDB.isComplete == false) {
          this.canCompleteCaseFile = true;
          this.RefreshStudentInfo();
        }
        else {
          this.canCompleteCaseFile = false;
          this.GetStudentInfo();
        }
      },
        err => {
          this.errorHandler(err);
        }
      );
  }

  GetSPTReferralDetails() {
    this._sPTProcessService.getSPTReferralForCase(this.selectedCaseFileId)
      .subscribe((res: ISPTReferral[]) => {
        this.sptReferralDB = res[0]; //get first element
        this.viewReferral = true;
        this.sptReferralDB.sptScheduledDate = this.sptReferralDB.sptScheduledDate == null ? null : new Date(this.sptReferralDB.sptScheduledDate);
        if (this.canEdit == true) {
          if (this.sptReferralDB.isComplete == true) {
            this.canCompleteCaseFile = true;
          }
          else {
            this.canEditReferral = true;
            this.canCompleteCaseFile = false;
          }
        }
        //PreReferralStrategy Tab
        if (this.sptReferralDB.isComplete == true) {
          this.GetSPTPreReferralStrategyDetails()
        }
      },
        err => {
          this.errorHandler(err);
        }
      );
  }

  GetSPTPreReferralStrategyDetails() {
    this._sPTProcessService.getSPTPreReferralStrategyForCase(this.selectedCaseFileId)
      .subscribe((res: ISPTPreReferralStrategyForm[]) => {
        if (res.length > 0) {
          this.sptPreReferralStrategyDB = res[0]; //get first element;
          this.viewPreReferralStrategies = true;
          if (this.canEdit == true) {
            if (this.sptPreReferralStrategyDB.isComplete == true) {
              this.canEditPreReferralStrategies = false;
              this.canCompleteCaseFile = true;
            }
            else {
              this.canEditPreReferralStrategies = true;
              this.canCompleteCaseFile = false;
            }
          }
          //MeetingLog Tab
          if (this.sptPreReferralStrategyDB.isComplete == true) {
            this.GetSPTMeetingLogDetails()
          }
        }
        else {
          this.addSPTPreReferralStrategy()
        }
      },
        err => {
          this.errorHandler(err);
        }
      );
  }

  GetSPTMeetingLogDetails() {
    this._sPTProcessService.getSPTMeetingLogForCase(this.selectedCaseFileId)
      .subscribe((res: ISPTMeetingLog[]) => {
        if (res.length > 0) {
          this.sptMeetingLogDB = res[0]; //get first element;
          this.viewMeetingLog = true;
          this.sptMeetingLogDB.followUpDate = this.sptMeetingLogDB.followUpDate == null ? null : new Date(this.sptMeetingLogDB.followUpDate);
          if (this.canEdit == true) {
            if (this.sptMeetingLogDB.isComplete == true) {
              this.canEditMeetingLog = false;
              this.canCompleteCaseFile = true;
            }
            else {
              this.canEditMeetingLog = true;
              this.canCompleteCaseFile = false;
            }
          }
          if (this.sptMeetingLogDB.isComplete == true) {
            this.GetSTPResponseToInterventionDetails()
          }
        }
        else {
          this.addSPTMeetingLog()
        }
      },
        err => {
          this.errorHandler(err);
        }
      );
  }

  GetSTPResponseToInterventionDetails() {
    this._sPTProcessService.getSPTResponseToInterventionForCase(this.selectedCaseFileId)
      .subscribe((res: ISPTResponseToIntervention[]) => {
        if (res.length > 0) {
          this.sptResponseToInterventionDB = res[0]; //get first element;
          this.viewResponseToIntervention = true;
          if (this.canEdit == true) {
            if (this.sptResponseToInterventionDB.isComplete == true) {
              this.canEditResponseToIntervention = false;
              this.canCompleteCaseFile = true;
            }
            else {
              this.canEditResponseToIntervention = true;
              this.canCompleteCaseFile = false;
            }
          }
          if (this.sptResponseToInterventionDB.isComplete == true) {
            this.viewAncillaryDocument = true;
            this.GetSPTDocuments();
            this.viewDocumentRepository = true;
            this.GetSPTBlankDocuments();
          }
        }
        else {
          this.addSPTResponseToIntervention()
        }
      },
        err => {
          this.errorHandler(err);
        }
      );
  }

  GetSPTDocuments() {
    this.showSpinner = true;
    this._sPTProcessService.getAllDocuments(this.selectedCaseFileId)
      .subscribe((res: ISPTDocument[]) => {
        this.sptDocument = res;
        this.showSpinner = false;
      },
        err => {
          this.errorHandler(err);
          this.showSpinner = false;
        }
      );
  }

  GetSPTBlankDocuments() {
    this.showSpinner = true;
    this._sPTProcessService.getAllBlankDocuments()
      .subscribe((res: ISPTBlankDocument[]) => {
        this.sptBlankDocument = res;
        this.showSpinner = false;
      },
        err => {
          this.errorHandler(err);
          this.showSpinner = false;
        }
      );
    this.LoadLookupValues();
  }

  addReferral() {
    this.clearMessages();
    this.viewReferral = true;
    this.viewPreReferralStrategies = false;
    this.viewMeetingLog = false;
    this.viewResponseToIntervention = false;
    this.viewAncillaryDocument = false;
    this.viewDocumentRepository = false;
    this.canEditReferral = true;
    this.sptReferralDB = {} as ISPTReferral;
    this.sptReferralDB.localStudentId = this._myGlobals.selectedStudent.localStudentId;
    this.sptReferralDB.id = 0;
    this.sptReferralDB.caseFileId = null;
    this.sptReferralDB.referralInitiatedByName = null;
    this.sptReferralDB.referralInitiatedByTitle = null;
    this.sptReferralDB.referralInitiatedByPhone = null;
    this.sptReferralDB.languageSpeech = null;
    this.sptReferralDB.languageVocabulary = null;
    this.sptReferralDB.languageComprehension = null;
    this.sptReferralDB.languageExpressesPoorly = null;
    this.sptReferralDB.languageFollowingDirections = null;
    this.sptReferralDB.languageOtherText = null;
    this.sptReferralDB.visualDyslexia = null;
    this.sptReferralDB.visualReversal = null;
    this.sptReferralDB.visualAcuity = null;
    this.sptReferralDB.visualOtherText = null;
    this.sptReferralDB.auditoryOralDirections = null;
    this.sptReferralDB.auditoryHearing = null;
    this.sptReferralDB.auditoryOtherText = null;
    this.sptReferralDB.socialPreoccupied = null;
    this.sptReferralDB.socialConstantSupervision = null;
    this.sptReferralDB.socialOverreacts = null;
    this.sptReferralDB.socialNegativeFeelings = null;
    this.sptReferralDB.socialDifficultyConforming = null;
    this.sptReferralDB.socialFights = null;
    this.sptReferralDB.socialGroups = null;
    this.sptReferralDB.socialSituations = null;
    this.sptReferralDB.socialFewFriends = null;
    this.sptReferralDB.socialOtherText = null;
    this.sptReferralDB.attentionDirections = null;
    this.sptReferralDB.attentionStayingOnTask = null;
    this.sptReferralDB.attentionOveractive = null;
    this.sptReferralDB.attentionTaskCompletion = null;
    this.sptReferralDB.attentionOtherText = null;
    this.sptReferralDB.motorFoldingPaper = null;
    this.sptReferralDB.motorHoldingPencil = null;
    this.sptReferralDB.motorCopyTrace = null;
    this.sptReferralDB.motorSimplePhysical = null;
    this.sptReferralDB.motorOtherText = null;
    this.sptReferralDB.commentsText = null;
    this.sptReferralDB.sptScheduled = null;
    this.sptReferralDB.sptScheduledDate = null;
    this.sptReferralDB.actionTakenNotes = null;
    this.sptReferralDB.isComplete = null;
    this.sptReferralDB.status = null;

    this.scrollToBottom();
  }

  addSPTPreReferralStrategy() {
    this.clearMessages();
    this.viewPreReferralStrategies = true;
    this.canEditPreReferralStrategies = true;
    this.sptPreReferralStrategyDB = {} as ISPTPreReferralStrategyForm;
    this.sptPreReferralStrategyDB.localStudentId = this._myGlobals.selectedStudent.localStudentId;
    this.sptPreReferralStrategyDB.id = 0;
    this.sptPreReferralStrategyDB.caseFileId = this.selectedCaseFileId;
  }

  addSPTMeetingLog() {
    this.clearMessages();
    this.viewMeetingLog = true;
    this.canEditMeetingLog = true;
    this.sptMeetingLogDB = {} as ISPTMeetingLog;
    this.sptMeetingLogDB.localStudentId = this._myGlobals.selectedStudent.localStudentId;
    this.sptMeetingLogDB.id = 0;
    this.sptMeetingLogDB.caseFileId = this.selectedCaseFileId;
  }

  addSPTResponseToIntervention() {
    this.clearMessages();
    this.viewResponseToIntervention = true;
    this.canEditResponseToIntervention = true;
    this.sptResponseToInterventionDB = {} as ISPTResponseToIntervention;
    this.sptResponseToInterventionDB.localStudentId = this._myGlobals.selectedStudent.localStudentId;
    this.sptResponseToInterventionDB.id = 0;
    this.sptResponseToInterventionDB.caseFileId = this.selectedCaseFileId;
  }

  //Save
  saveReferral() {
    this.clearMessages();
    this.validateForm();
    if (this.validation == true) {
      this.saveClicked = true;
      //update values
      this._sPTProcessService.insertUpdateSPTReferral(this.sptReferralDB)
        .subscribe((res: ISPTReferral) => {
          let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
          this.addMessage(successMessage);
          this.saveClicked = false;
          this.GetSPTProcess();
          this.CloseReferral();
          this.scrollToTop();
        },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
            this.addMessage(errorMessage);
            this.saveClicked = false;
          }
        )
    }
  }

  saveSPTPreReferralStrategy() {
    this.clearMessages();
    this.saveClicked = true;
    //update values
    this._sPTProcessService.insertUpdateSPTPreReferralStrategy(this.sptPreReferralStrategyDB)
      .subscribe((res: ISPTPreReferralStrategyForm) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        this.saveClicked = false;
        this.activeTab = 1;
        this.GetSPTPreReferralStrategyDetails();
        this.scrollToTop();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  saveSPTMeetingLog() {
    this.clearMessages();
    this.saveClicked = true;
    //update values
    this._sPTProcessService.insertUpdateSPTMeetingLog(this.sptMeetingLogDB)
      .subscribe((res: ISPTMeetingLog) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        this.saveClicked = false;
        this.activeTab = 2;
        this.GetSPTMeetingLogDetails();
        this.scrollToTop();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  saveSPTResponseToIntervention() {
    this.clearMessages();
    this.saveClicked = true;
    //update values
    this._sPTProcessService.insertUpdateSPTResponseToIntervention(this.sptResponseToInterventionDB)
      .subscribe((res: ISPTResponseToIntervention) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        this.saveClicked = false;
        this.activeTab = 3;
        this.GetSTPResponseToInterventionDetails();
        this.scrollToTop();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  UploadSPTDocument() {
    this.clearMessages();
    this.saveClicked = true;
    this._sPTProcessService.insertSPTDocument(this.sptDocumentDB)
      .subscribe((res: ISPTDocument) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        this.saveClicked = false;
        this.activeTab = 4;
        this.scrollToTop();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  UploadSPTBlankDocument() {
    this.clearMessages();
    this.saveClicked = true;
    //update values
    this._sPTProcessService.insertUpdateSPTBlankDocument(this.sptBlankDocumentDB)
      .subscribe((res: ISPTBlankDocument) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        this.saveClicked = false;
        this.activeTab = 5;
        this.scrollToTop();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  completeCaseFile() {
    this.confirmation.confirm({
      key: 'confirm-complete-casefile',
      message: 'Are you sure want to complete the Case? If you complete, you can not update this SPT Process again.',
      accept: () => { this.saveCaseFile(); },
    });
  }

  saveCaseFile() {
    this.clearMessages();
    this.saveClicked = true;
    //update IsComplete
    this.sptCaseFileDB.IsComplete = true;
    this._sPTProcessService.insertUpdateSPTCaseFile(this.sptCaseFileDB)
      .subscribe((res: ISPTCaseFile) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        this.saveClicked = false;
        this.GetSPTProcess();
        this.CloseReferral();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  LoadLookupValues() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.SPTDocumentType])
      .subscribe((res: ILookupBase[]) => {
        this._lookupDocumentType = [] as ILookupBase[];
        this._lookupDocumentType.push({ label: '-- Select Choice --', value: null, shortText: 'Select Choice', updatedOn: null });
        this._lookupDocumentType.push.apply(this._lookupDocumentType, res);
      },
        err => {
          this.errorHandler(err);
        }
      );
  }

  validateForm() {
    this.validation = true;
    if (this.sptReferralDB.referralInitiatedByName == null || this.sptReferralDB.referralInitiatedByName == '') {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Person Making Referral Name is missing'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
    if (this.sptReferralDB.referralInitiatedByTitle == null || this.sptReferralDB.referralInitiatedByTitle == '') {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Person Making Referral Title is missing'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
    if (this.sptReferralDB.referralInitiatedByPhone == null || this.sptReferralDB.referralInitiatedByPhone == '') {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Person Making Referral Phone is missing'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
    if (this.sptReferralDB.primaryObservedStudentIssue == null || this.sptReferralDB.primaryObservedStudentIssue == '') {
      let errorMessage: Message = {
        severity: 'error', summary: 'Validation Error', detail: 'Primary Behavior/Learning Problem Observed is missing'
      };
      this.addMessage(errorMessage);
      this.validation = false;
    }
  }

  addMessage(msg: Message) {
    if (!this.messages)
      this.messages = [];
    this.messages = [...this.messages, msg];
  }

  clearMessages() {
    this.messages = [];
  }

  CloseReferral(): void {
    this.clearMessages();
    this.viewReferral = false;
    this.viewPreReferralStrategies = false;
    this.viewMeetingLog = false;
    this.viewResponseToIntervention = false;
    this.viewAncillaryDocument = false;
    this.viewDocumentRepository = false;
    this.canEdit = false;
    this.canEditReferral = false;
    this.canEditPreReferralStrategies = false;
    this.canEditMeetingLog = false;
    this.canEditResponseToIntervention = false;
    this.canEditAncillaryDocument = false;
    this.canEditDocumentRepository = false;
  }

  scrollToBottom(): void {
    let pos = window.pageYOffset;
    //Scroll the from to position horizontally 0 and vertically 500
    if (pos < 500) {
      window.scrollTo(0, 500);
    }
  }

  scrollToTop(): void {
    let pos = window.pageYOffset;
    //Scroll the from to position horizontally 0 and vertically 500
    if (pos > 500) {
      window.scrollTo(0, 500);
    }
  }

  cancel() {
    this.clearMessages();
    this.activeTab = 0;
    //this.viewPreReferralStrategies = false;
    //this.viewMeetingLog = false;
    //this.viewResponseToIntervention = false;
    //this.viewAncillaryDocument = false;
    //this.viewDocumentRepository = false;
  }

  errorHandler(error: Response): Observable<any> {
    console.log(error);
    return Observable.throw(error);
  }

  printEnglish() {

  }

}
